export default __webpack_public_path__ + "static/media/block-user.6adf781b.png";